module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-05017a9f.png";